import { render, staticRenderFns } from "./CommonSelect.vue?vue&type=template&id=19535c3c&scoped=true"
import script from "./CommonSelect.vue?vue&type=script&lang=js"
export * from "./CommonSelect.vue?vue&type=script&lang=js"
import style0 from "./CommonSelect.vue?vue&type=style&index=0&id=19535c3c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19535c3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2326903440/src/bitbucket.org/Modis-ito/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19535c3c')) {
      api.createRecord('19535c3c', component.options)
    } else {
      api.reload('19535c3c', component.options)
    }
    module.hot.accept("./CommonSelect.vue?vue&type=template&id=19535c3c&scoped=true", function () {
      api.rerender('19535c3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/drc/pages/submit-form/components/CommonSelect.vue"
export default component.exports